import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import FalconLink from '@/components/common/FalconLink';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import { ReferringIpSmallTable } from '../columnsConfig';
import { useSearchParams } from 'react-router-dom';
import { useBacklinkSectionHref } from '../utils/useBacklinkSectionHref';
import PlotSkeleton from './PlotSkeleton';

const TABLE_HEIGHT = '300px';

const ReferringIpTable = ({ data, loading = false }: Record<string, any>) => {
  const [searchParams] = useSearchParams();
  const moreHref = useBacklinkSectionHref('/backlink/referring-ip', {
    ip_prefix: searchParams.get('ip_prefix') || undefined
  });

  return (
    <Card className="h-100 ag-grid-in-card">
      <Card.Body className="position-relative p-0 mt-0 pt-0">
        {loading ? (
          <PlotSkeleton height={TABLE_HEIGHT} />
        ) : (
          <AgGridWrapper
            otherOptions={{ pagination: false }}
            columns={ReferringIpSmallTable}
            data={data}
            height={TABLE_HEIGHT}
          />
        )}
      </Card.Body>

      <Card.Footer className="bg-body-tertiary text-end py-2">
        <FalconLink
          title="بیشتر"
          to={moreHref}
          className="px-0 fw-medium"
        />
      </Card.Footer>
    </Card>
  );
};

ReferringIpTable.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool
};

export default ReferringIpTable;
